import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLanguage } from "@/i18n";

const PaymentCancel = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="payment-cancel-page" className="pt-24 min-h-[80vh] flex items-center">
      <div className="max-w-2xl mx-auto px-6 text-center py-32">
        <XCircle size={56} className="mx-auto text-clay" />
        <h1 className="mt-8 font-serif text-4xl md:text-6xl text-forest" data-testid="payment-cancel-title">{t("payment.cancelledTitle")}</h1>
        <p className="mt-4 text-sage text-lg">{t("payment.cancelledText")}</p>
        <Link to="/campaigns" data-testid="payment-try-again" className="mt-10 inline-flex bg-forest text-cream px-8 py-4 rounded-full font-medium hover:bg-clay hover:-translate-y-0.5 transition-transform duration-300">
          {t("payment.tryAgain")}
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
